module.exports = "<div data-ng-attr-id=\"{{ vm.recaptchaId }}\" data-ng-attr-data-size=\"{{ vm.recaptchaSize }}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/googlerecaptcha/google-recaptcha.view.html
// module id = 55
// module chunks = 0